import React from 'react';
import { useSsmUiFlags } from '@utilities/hooks/useSsmUiFlags/useSsmUiFlags';
import { useSelector } from 'react-redux';
import { UserProfileHasARoleSelector, UserProfileDetailsSelector } from '@store/selectors/UserProfileSelector';
import { OfficeRoles } from '@interfaces/UserProfile/UserRoleEnum';
import { BuilderConfig } from '@components/Chat/BuilderConfig';
import { useIsChatEnabled } from '@components/Chat/hooks/useIsChatEnabled/useIsChatEnabled';

const isBuilderConfig = (config: unknown): config is BuilderConfig => {
	return typeof config === 'object' &&  config !== null && 'chatFeatures' in config;
};

export const useChatBuilderConfig = (): BuilderConfig | undefined => {
	const { ssmLiveChatConfig } = useSsmUiFlags();
	const hasOfficeRole = useSelector(UserProfileHasARoleSelector(OfficeRoles));
	const { username } = useSelector(UserProfileDetailsSelector);
	const { isChatEnabled } = useIsChatEnabled();

	return React.useMemo(() => {
		if (
			!isChatEnabled ||
			!isBuilderConfig(ssmLiveChatConfig) || // use type assertion to address type error
			Object.keys(ssmLiveChatConfig).length === 0 || // empty object = LD flag off
			!username
		) {
			return undefined;
		}

		const ministry = username.split('\\')[0];

		return {
			...ssmLiveChatConfig,
			appId: window.config.CHAT_APP_ID,
			fcmProviderId: window.config.FCM_PROVIDER_ID,
			filterRoles: hasOfficeRole ? ['ssm_or_scheduler'] : ['ssm_office_scheduler'],
			filterTags: ministry ? [ministry] : [],
		};
	}, [isChatEnabled, ssmLiveChatConfig, username, hasOfficeRole]);
};
